export default __webpack_public_path__ + "static/media/13.ebb9f170.PNG";